(function () {
  function init(root) {
    if (root.dataset.nativeBundleReady === '1') return;
    root.dataset.nativeBundleReady = '1';

    const form = root.querySelector('form.zap__form');
    const mapNode = root.querySelector('[data-zap-native-variants]');
    const button = root.querySelector('.zap__add');
    const errorBox = root.querySelector('.product-form__error-message-wrapper');
    const errorText = root.querySelector('.product-form__error-message');
    if (!form || !mapNode || !button) return;
    form.noValidate = true;

    let variants;
    try {
      variants = JSON.parse(mapNode.textContent);
    } catch (error) {
      variants = {};
    }

    function showError(message) {
      if (errorText) errorText.textContent = message;
      if (errorBox) errorBox.hidden = false;
    }

    function selectedItems() {
      const pack = root.querySelector('[data-zap-pack]:checked');
      if (!pack) throw new Error('Wybierz zestaw.');
      const count = Number(pack.dataset.pieces);
      const lookup = variants[String(count)] || {};
      const adjustedCount = count === 6 ? 3 : 1;
      const pieces = Array.from(root.querySelectorAll('[data-zap-piece]'))
        .filter((piece) => !piece.disabled && !piece.hidden);
      if (pieces.length !== count) throw new Error('Wybierz kolor i rozmiar każdej sztuki.');

      const grouped = new Map();
      for (let index = 0; index < pieces.length; index += 1) {
        const piece = pieces[index];
        const size = piece.querySelector('select[name*="_Rozmiar"]')?.value;
        const color = piece.querySelector('select[name*="_Kolor"]')?.value;
        if (!size || !color) {
          const error = new Error('Wybierz rozmiar i kolor sztuki ' + piece.dataset.zapPiece + '.');
          error.field = piece.querySelector(size ? 'select[name*="_Kolor"]' : 'select[name*="_Rozmiar"]');
          throw error;
        }
        const role = index < adjustedCount ? 'adjusted' : 'base';
        const id = Number(lookup[role]?.[color + '|' + size]);
        if (!Number.isSafeInteger(id) || id <= 0) {
          throw new Error('Ten wariant jest chwilowo niedostępny.');
        }
        grouped.set(id, (grouped.get(id) || 0) + 1);
      }
      const items = Array.from(grouped, ([id, quantity]) => ({ id, quantity }));
      if (items.reduce((sum, item) => sum + item.quantity, 0) !== count) {
        throw new Error('Nie udało się przygotować zestawu.');
      }
      return items;
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (button.disabled) return;
      if (errorBox) errorBox.hidden = true;

      let items;
      try {
        items = selectedItems();
      } catch (error) {
        showError(error.message);
        error.field?.focus();
        return;
      }

      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((section) => section.section || section.id).filter(Boolean).slice(0, 5)
        : ['cart-drawer', 'cart-icon-bubble'];
      if (drawer && typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(document.activeElement);
      }
      const rootUrl = window.Shopify?.routes?.root || '/';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      let added = false;
      try {
        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || 'Nie udało się dodać zestawu do koszyka.');
        }
        added = true;

        const cartResponse = await fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: {},
            sections,
            sections_url: window.location.pathname
          })
        });
        const cart = await cartResponse.json();
        if (!cartResponse.ok || cart.status) {
          throw new Error(cart.description || 'Nie udało się odświeżyć koszyka.');
        }
        const hasAddedItems = items.every((entry) =>
          cart.items?.some((line) => Number(line.variant_id) === entry.id && Number(line.quantity) >= entry.quantity)
        );
        if (!hasAddedItems) throw new Error('Nie udało się potwierdzić zawartości koszyka.');

        if (drawer && cart.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
          // The theme marks the drawer itself as empty after its last line is removed.
          // Its renderContents method only clears that state on the inner element.
          drawer.classList.remove('is-empty');
          drawer.renderContents(cart);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } else {
          window.location.assign(rootUrl + 'cart');
        }
      } catch (error) {
        if (added) {
          window.location.assign(rootUrl + 'cart');
        } else {
          showError(error.message || 'Nie udało się dodać zestawu do koszyka.');
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-zap-native-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

